import React from "react";
import { withTranslation } from "react-i18next";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
class AbuseChRansomAdapterFieldSet extends React.Component {
  constructor() {
    super(...arguments);
    this._update = (value, unit, enabled, name) => {
      const config = ObjectUtils.clone(this.props.config);
      config[name] = enabled ? value : 0;
      config[`${name}_unit`] = unit;
      this.props.updateConfig(config);
    };
    this.updateRefreshInterval = (value, unit, enabled) => {
      this._update(value, unit, enabled, "refresh_interval");
    };
    this._onBlocklistTypeSelect = (id) => {
      const config = ObjectUtils.clone(this.props.config);
      config.blocklist_type = id;
      this.props.updateConfig(config);
    };
  }
  render() {
    const { config, t } = this.props;
    const blocklistTypes = [
      { label: t("abusech_ransom_adapter_field_set.domains_blocklist"), value: "DOMAINS" },
      { label: t("abusech_ransom_adapter_field_set.urls_blocklist"), value: "URLS" },
      { label: t("abusech_ransom_adapter_field_set.ips_blocklist"), value: "IPS" }
    ];
    return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        label: t("abusech_ransom_adapter_field_set.blocklist_type_label"),
        id: "blocklist-type-selector",
        required: true,
        autoFocus: true,
        help: t("abusech_ransom_adapter_field_set.blocklist_type_help"),
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: t("abusech_ransom_adapter_field_set.blocklist_type_placeholder"),
          clearable: false,
          options: blocklistTypes,
          onChange: this._onBlocklistTypeSelect,
          value: config.blocklist_type
        }
      )
    ), /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: t("abusech_ransom_adapter_field_set.refresh_blocklist_label"),
        help: t("abusech_ransom_adapter_field_set.refresh_blocklist_help"),
        update: this.updateRefreshInterval,
        value: config.refresh_interval,
        unit: config.refresh_interval_unit || "MINUTES",
        defaultEnabled: config.refresh_interval > 0,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ));
  }
}
export default withTranslation("integrations")(AbuseChRansomAdapterFieldSet);
